<div>
    <div [chart]="serverChart"></div>
</div>